// extracted by mini-css-extract-plugin
export var text = "_3s-0";